import commonUtils from "@/utils/common.utils";

export default class OrderSpec {
    constructor(setting) {
        this.id = commonUtils.generateId();
        this.subSpecOptionSelectCount = setting.subSpecOptionSelectCount;
        this.mustHave = setting.mustHave;
        this.frontEndDisplayName = setting.frontEndDisplayName;
        this.isSingleSelection = setting.isSingleSelection;
        this.multiSelectionMin = setting.multiSelectionMin;
        this.multiSelectionMax = setting.multiSelectionMax;
        this.allowSelectManyTimes = setting.allowSelectManyTimes;
        this.productSpec = new ProductSpec(setting);
    }
}

class ProductSpec {
    constructor(setting) {
        this.id = setting.id;
        this.enableForProductComboSpec = setting.enableForProductComboSpec;
        this.enableForOrderSpec = setting.enableForOrderSpec;
        this.name = setting.name;
        this.stickerTagPrintName = setting.stickerTagPrintName || "";
        this.specOptions = setting.specOptions.map(option => {
            return {
                id: commonUtils.generateId(),
                ...option
            }
        });
    }
}